import { render, staticRenderFns } from "./PaywaitScreen.vue?vue&type=template&id=d2f2dbe2&scoped=true"
import script from "./PaywaitScreen.vue?vue&type=script&lang=js"
export * from "./PaywaitScreen.vue?vue&type=script&lang=js"
import style0 from "./PaywaitScreen.vue?vue&type=style&index=0&id=d2f2dbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f2dbe2",
  null
  
)

export default component.exports